import React from 'react';
import Responsive from '@amzn/meridian/responsive';
import { responsiveProps } from 'src/constants/responsiveProps';
import ScanSortType from 'src/components/pages/sort-page/scan-sort-type-page/ScanSortTypeContainer';
import ScanSourceForSort from 'src/components/pages/sort-page/scan-source-for-sort-page/ScanSourceForSortContainer';
import ScanDestinationForSort
    from 'src/components/pages/sort-page/scan-destination-for-sort-page/ScanDestinationForSortContainer';
import { SortContainerPages } from 'src/store/common-slices/sortContainerSlice';
import { buildGetSortTypesInput, GetSortTypesInput } from 'src/models/GetSortTypes';
import { BatchMoveContainersMode } from 'src/store/common-slices/batchMoveContainersSlice';
import UILoader from 'src/components/common/loader/UILoaderContainer';
import StatusAlert from 'src/components/common/status-alert/StatusAlertContainer';
import './Sortation.scss';
import Column from "@amzn/meridian/column";

interface SortationStateProps {
    pageToRender: SortContainerPages;
    warehouseId: string;
    associate: string;
    locale: string;
}

interface SortationDispatchProps {
    getSortTypes: (getSortTypesInput: GetSortTypesInput) => void;
    resetGetSortTypesOutput: () => void;
    setBatchMoveMode: (batchMoveContainersMode: BatchMoveContainersMode) => void;
}

type Props = SortationStateProps & SortationDispatchProps;

class Sortation extends React.Component<Props> {

    componentDidMount() {
        this.props.getSortTypes(buildGetSortTypesInput(this.props.warehouseId, this.props.associate, this.props.locale));
        this.props.setBatchMoveMode(BatchMoveContainersMode.SINGLE_MODE);
    }

    componentWillUnmount() {
        this.props.resetGetSortTypesOutput();
    }

    public render() {
        return(
            <Responsive query={"max-width"} props={responsiveProps}>
                {props => (
                    <Column className="sortation">
                        {this.props.pageToRender === SortContainerPages.SELECT_SORT_TYPE_PAGE && <ScanSortType/>}
                        {this.props.pageToRender === SortContainerPages.SCAN_SOURCE_CONTAINER_PAGE && <ScanSourceForSort/>}
                        {this.props.pageToRender === SortContainerPages.SCAN_DESTINATION_CONTAINER_PAGE && <ScanDestinationForSort/>}

                        <UILoader />
                        <StatusAlert />

                    </Column>
                )}
            </Responsive>
        );
    }
}

export default Sortation;
